// extracted by mini-css-extract-plugin
module.exports = {"event":"styles-module--event--2uriJ","sideLabel":"styles-module--sideLabel--3pmmK"};